import React, { useContext, useEffect, useState } from 'react';
import { lazy } from "react";
import Footer from '../../../../components/Footer';
import Header from '../../../../components/Header';
import Container from "../../../Container";
import { CancelButton } from '../../../Button/CancelButton';
import { SubmitButton } from '../../../Button/SubmitButton';
import Grid from "@material-ui/core/Grid";
import { InnerPage, GridSkin, ContainerStyle01, ButtonDiv, ConfirmMsg, ConfirmationMsg1, ConfirmationMsg, HeadingContent, PageHeadingInner } from '../styles'
import { useHistory } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { SvgIcon } from '../../../SvgIcon';
import { LangContext, ServiceAvailContext } from '../../../../context/UserContext';
import { Styles } from "../../../../styles/styles";

interface FallBackCompoProps {
  t?: any
  step?:any
}

const FallBackCompo = ({t, step}: FallBackCompoProps) => {
  const history = useHistory();
  const languageCheck: any = useContext(LangContext);
  const serverCheck: any = useContext(ServiceAvailContext);
  const [errorMsg, setErrorMsg] = useState("FALL_UI_MSG");

  let count = 0;
useEffect(()=>{
  if (count === 0) {
  if(step !== undefined){
    if(step.payload.message!=="Login failure"){
      if(step.payload.message!==undefined || step.payload.message!==""){
        setErrorMsg(step.payload.message);
      }else{
        setErrorMsg("FALL_UI_MSG");
      }
    }else{
      setErrorMsg("FALL_UI_MSG");
    }
  }else{
    setErrorMsg("FALL_UI_MSG");
  }
  count++;
}
},[]);

  const handleCancel = () => {
    serverCheck.setServiceNotAvail(false);
    window.open("/", "_self");
  };

  return (
    <>
      <Container>
        <InnerPage>
          <GridSkin>
            <ConfirmMsg>
              <Grid item lg={12} container>
                <Grid item lg={2} xs={4}>
                  <ConfirmationMsg1 isArabic={languageCheck.language}>
                    <SvgIcon src="icon-informative-xlarge.png" width="100px" height="100px" />
                  </ConfirmationMsg1>
                </Grid>
                <Grid item lg={10} xs={8}>
                  <ConfirmationMsg isArabic={languageCheck.language}>
                   <p>{t(errorMsg)}</p>
                  </ConfirmationMsg>
                </Grid>
              </Grid>
            </ConfirmMsg>
            <ContainerStyle01>
              <ButtonDiv>
                <CancelButton float={languageCheck.language?"left" : "right"} width="150px" onClick={handleCancel} color="white" background="linear-gradient(0deg, rgba(139,136,136,1), rgba(59,57,57,1), rgba(139,136,136,1))">{t("FALL_UI_BUTTON")}</CancelButton>
              </ButtonDiv>
            </ContainerStyle01>
          </GridSkin>
        </InnerPage>
      </Container>
    </>
  );
};

export default withTranslation()(FallBackCompo);
